import { Title } from '../../../components'
import {
    Container
} from './styles'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Documentação</Title>

                    <section className="mt-2 p-3">

                        <p>
                        Axial e coronal P.M. utilizar ww 300 e wl 45;
                            <br/>
                            Axial e coronal Osso utilizar ww 2.500 e wl 500;
                        </p>
                        <p>
                            <b>Axial P.M. -</b> 1 filme na formatação de 20 imagens;<br/>
                            <b>Axial Osso -</b> 1 filme na formatação de 20 imagens;<br/>
                            <b>Coronal P.M. -</b> 1 filme na formatação de 20 imagens;<br/>
                            <b>Coronal Osso -</b> 1 filme na formatação de 20 imagens;<br/>
                            <b>3D VR Quadril Dir. / Esq. -</b> 1 filme na formatação de 12 imagens;<br/>
                        </p>

                        <p>
                            <b>Impressão Mista, Filme e Papel</b><br/>
                            Axial em filme; <br/>
                            Coronal em papel;<br/>
                        </p>
                        <p>
                            <b>Impressão apenas em Papel</b><br/>
                            Axial em papel;<br/>
                            Coronal em papel;<br/>
                        </p>
                    </section>
                </div>
            </div>
        </Container>
    )
}